// hooks/useLocation.js
import { useState, useEffect } from 'react';

/**
 * Usa ipapi.co para geolocalización basada en IP
 */
export const useLocation = () => {
  const [location, setLocation] = useState({
    country: 'ES',        // Código de país (ISO 3166-1 alpha-2)
    countryName: 'España', // Nombre completo del país
    city: null,           // Ciudad (opcional)
    loading: true,        // Estado de carga
    error: null          // Error si falla la detección
  });

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        // Usar ipapi.co (gratuito, 30k requests/mes)
        const response = await fetch('https://ipapi.co/json/');
        
        if (!response.ok) {
          throw new Error('Error al obtener ubicación');
        }
        
        const data = await response.json();
        
        console.log('📍 Ubicación detectada:', {
          country: data.country_code,
          countryName: data.country_name,
          city: data.city
        });
        
        setLocation({
          country: data.country_code || 'ES',
          countryName: data.country_name || 'España',
          city: data.city,
          loading: false,
          error: null
        });
      } catch (error) {
        console.error('❌ Error detectando ubicación:', error);
        
        // Fallback: España por defecto
        setLocation({
          country: 'ES',
          countryName: 'España',
          city: null,
          loading: false,
          error: error.message
        });
      }
    };

    fetchLocation();
  }, []); // Solo ejecutar al montar el componente

  return location;
};

export default useLocation;
